import React from 'react';
import PropTypes from 'prop-types';

import { createFormFieldsByIdGetter } from 'client/helpers/formikHelpers';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrAddressInput = ({ formikBag, formFields }) => {
  const _onClickSwitch = () => {
    formikBag.setFieldValue('locationLatitude', null);
    formikBag.setFieldValue('locationLongitude', null);
    formikBag.setFieldValue('addressStreetDisplay', null);
    formikBag.setFieldValue('manualAddressInput', !formikBag.values.manualAddressInput);
  };

  const getFormFieldsById = createFormFieldsByIdGetter(formFields);
  const clientWantsPropertyManagementField = getFormFieldsById('clientWantsPropertyManagement');

  return (
    <>
      <SrCard>
        {formFields
          .filter((formField) => formField.id !== 'clientWantsPropertyManagement')
          .map((formField, index) => (
            <SrBox key={formField.id}>
              <SrFormikField
                formField={formField}
                formikBag={formikBag}
                theme={SR_FIELD_THEME_ADOBE}
                margin={index === 0 ? '0px' : null}
              />
            </SrBox>
          ))}
        {clientWantsPropertyManagementField && (
          <SrGridRow columns={1} width="410px">
            <SrFormikField
              formField={clientWantsPropertyManagementField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
          </SrGridRow>
        )}
      </SrCard>

      <SrBox marginTop="24px" textAlign="center">
        <SrText
          font="greycliff"
          color="blue300"
          weight="bold"
          cursor="pointer"
          onClick={_onClickSwitch}
        >
          {formikBag.values.manualAddressInput
            ? 'Go back to search the address'
            : "Can't find it? Enter address manually"}
        </SrText>
      </SrBox>
    </>
  );
};

SrAddressInput.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrAddressInput.displayName = 'SrAddressInput';

export default SrAddressInput;
